import { render, staticRenderFns } from "./HardcodedProfilePage.vue?vue&type=template&id=2d368418&scoped=true&"
import script from "./HardcodedProfilePage.vue?vue&type=script&lang=js&"
export * from "./HardcodedProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./HardcodedProfilePage.vue?vue&type=style&index=0&id=2d368418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d368418",
  null
  
)

export default component.exports